/**
 * What the scope picker is told about the current filter (BON-538).
 *
 * The roster's `scope` block is the source. The picker needs only the region's
 * ID — it walks `parentId` itself to open the branch above it — so the block's
 * ancestors are for the breadcrumb, not for this. Null means no filter, which
 * the picker reads as all-regions.
 */
import type { VenueRosterResult } from './venues-roster-api';

export interface VenuesScope {
  /** What the current scope is called, for the header. */
  label: string;
  /** The region being viewed; null when unfiltered. */
  currentRegionId: string | null;
}

/**
 * `requested` is the slugs the roster was asked for. The server sends no scope
 * block for two or more regions, and without it a viewer's own several regions
 * would read as "All regions" — which is exactly what they are not looking at.
 */
export function scopeOf(
  data: VenueRosterResult | undefined,
  requested: string[] = [],
): VenuesScope {
  const scope = data?.scope;
  if (scope) return { label: scope.region.name, currentRegionId: scope.region.id };
  if (requested.length > 1) return { label: 'Your regions', currentRegionId: null };
  return { label: 'All regions', currentRegionId: null };
}
